import {
  LIST_RESPONSIBLE_DOCTOR_SUMMARY_REQUEST,
  LIST_RESPONSIBLE_DOCTOR_SUMMARY_SUCCESS,
  LIST_RESPONSIBLE_DOCTOR_SUMMARY_FAIL,
  LIST_RESPONSIBLE_DOCTOR_SUMMARY_RESET,
  LIST_RESPONSIBLE_DOCTOR_REQUEST,
  LIST_RESPONSIBLE_DOCTOR_SUCCESS,
  LIST_RESPONSIBLE_DOCTOR_FAIL,
  LIST_RESPONSIBLE_DOCTOR_RESET,
  CREATE_RESPONSIBLE_DOCTOR_REQUEST,
  CREATE_RESPONSIBLE_DOCTOR_SUCCESS,
  CREATE_RESPONSIBLE_DOCTOR_FAIL,
  DETAIL_RESPONSIBLE_DOCTOR_REQUEST,
  DETAIL_RESPONSIBLE_DOCTOR_SUCCESS,
  DETAIL_RESPONSIBLE_DOCTOR_FAIL,
  UPDATE_RESPONSIBLE_DOCTOR_REQUEST,
  UPDATE_RESPONSIBLE_DOCTOR_SUCCESS,
  UPDATE_RESPONSIBLE_DOCTOR_FAIL,
  DELETE_RESPONSIBLE_DOCTOR_REQUEST,
  DELETE_RESPONSIBLE_DOCTOR_SUCCESS,
  DELETE_RESPONSIBLE_DOCTOR_FAIL
} from '../../constants/responsible-doctors'

const initialState = {
  loading: false,
  responsibleDoctors: [],
  responsibleDoctor: {},
  responsibleDoctorsSummary: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const responsibleDoctorListReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_RESPONSIBLE_DOCTOR_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_RESPONSIBLE_DOCTOR_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        responsibleDoctorsSummary: action.payload
      }
    case LIST_RESPONSIBLE_DOCTOR_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_RESPONSIBLE_DOCTOR_SUMMARY_RESET:
      return { ...state, loading: false, responsibleDoctorsSummary: [] }
    case LIST_RESPONSIBLE_DOCTOR_REQUEST:
      return { ...state, loadingList: true }
    case LIST_RESPONSIBLE_DOCTOR_SUCCESS:
      return { ...state, loadingList: false, responsibleDoctors: action.payload, pageable: action.pageable }
    case LIST_RESPONSIBLE_DOCTOR_FAIL:
      return { ...state, loadingList: false, error: action.payload }
    case LIST_RESPONSIBLE_DOCTOR_RESET:
      return { ...state, loading: false, responsibleDoctors: [] }
    case CREATE_RESPONSIBLE_DOCTOR_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_RESPONSIBLE_DOCTOR_SUCCESS:
      return { ...state, loadingCreate: false, responsibleDoctors: [...state.responsibleDoctors, action.payload] }
    case CREATE_RESPONSIBLE_DOCTOR_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_RESPONSIBLE_DOCTOR_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_RESPONSIBLE_DOCTOR_SUCCESS:
      return { ...state, loadingDetail: false, responsibleDoctor: action?.payload }
    case DETAIL_RESPONSIBLE_DOCTOR_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_RESPONSIBLE_DOCTOR_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_RESPONSIBLE_DOCTOR_SUCCESS:
      const responsibleDoctorPayload = action.payload
      const responsibleDoctorIndex = state.responsibleDoctors.findIndex(responsibleDoctor => responsibleDoctor.id === responsibleDoctorPayload.id)

      const responsibleDoctorsUpdate = [...state.responsibleDoctors]
      responsibleDoctorsUpdate[responsibleDoctorIndex] = responsibleDoctorPayload

      return { ...state, loadingUpdate: false, responsibleDoctors: responsibleDoctorsUpdate }
    case UPDATE_RESPONSIBLE_DOCTOR_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_RESPONSIBLE_DOCTOR_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_RESPONSIBLE_DOCTOR_SUCCESS:
      const responsibleDoctorId = action.payload

      const responsibleDoctorIndexDelete = state.responsibleDoctors.findIndex(responsibleDoctor => responsibleDoctor.id === responsibleDoctorId)
      const responsibleDoctorsDelete = [...state.responsibleDoctors]

      responsibleDoctorsDelete.splice(responsibleDoctorIndexDelete, 1)

      return { ...state, loadingDelete: false, responsibleDoctors: responsibleDoctorsDelete }
    case DELETE_RESPONSIBLE_DOCTOR_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    default:
      return state
  }
}

export default responsibleDoctorListReducer